// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eMwci","questions":"styles_questions__3C-6d","footer":"styles_footer__MwUKj"};